import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import Conformance from './Conformance';
import ButtonAction from './ButtonAction';
import HelpPopover from './HelpPopover';
import EntityForm from './EntityForm';
import Collapsible from 'react-collapsible';
import { CONFORMANCE_FIELDS } from '../constants/Fixtures';
import ReactCSSTransition from 'react-transition-group/CSSTransition';

export default class ConformanceList extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      formIndex: 1,
      conformanceForm: false,
    };
  }

  getConformance() {
    return this.props.conformances || [];
  }

  toggleAddConformanceForm = () => {
    this.setState({
      conformanceForm: !this.state.conformanceForm,
      formIndex: this.state.formIndex + 1,
    });
  }

  addConformance = (attributes) => {
    // supply a default for category
    this.props.create(attributes);
    this.toggleAddConformanceForm();
  }

  conformanceFormText() {
    if (this.props.title) {
      return 'Add ' + this.props.title.replace(/s$/, '');
    } else {
      return 'Add Conformance';
    }
  }

  render() {
    return (<div className="section-list" id='conformance-list'>
      <Collapsible
        open={this.state.conformanceForm}
        trigger={
          <div
            className="section-header"
          >
            <h2>{this.props.title || 'Conformance'}</h2>
            <div className="float-md-end">
              <HelpPopover
                size="sm"
                name="conformance-description"
                placement={'left'}
                title="Conformance Metadata in the Digital Hub"
              >
                The Conforms To property is used to indicate that the ePub conforms to a published accessibility specification. Users can
                <ul style={{ marginBottom: '0' }}>
                  <li>
                    enter a URL in the description field, or
                  </li>
                  <li>
                    enter a text description and certifying organization.
                  </li>
                </ul>
                Certifying organizations are not included in an ePub when a conformance line references a URL. Scribe does NOT certify e-books against accessibility requirements. It is the publisher’s responsibility to gain the certification of the listed organization or individual before making the ePub available for users.
              </HelpPopover>
              <ButtonAction
                color='secondary'
                action={this.toggleAddConformanceForm}
                size="sm"
                icon={this.state.conformanceForm ? 'fa-arrow-circle-up' : 'fa-arrow-circle-down'}
              >
                {this.conformanceFormText()}
              </ButtonAction>
            </div>
          </div>
        }
      >
        <div >
        </div>
        </Collapsible>
      <Table className="section-table" responsive hover>
        <thead>
          <tr>
            <th>Description/URL</th>
            <th>Certifying Organization</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <ReactCSSTransition
          classNames="list-fold"
          timeout={{ enter: 500, exit: 500 }}>
          <tbody>
            { this.state.conformanceForm ? 
              <EntityForm
                key={`${this.props.title || 'conformance'}-form-${this.state.formIndex}`}
                fields={CONFORMANCE_FIELDS}
                action={this.addConformance}
                className="section-new-form"
              />
              :
              null
            }
            {this.getConformance().map((con, index) =>
                (<Conformance
                  key={`con-${con.id}`}
                  id={con.id}
                  description={con.description}
                  organization={con.organization}
                  destroy={this.props.destroy}
                  update={this.props.update}
                />),
            )}
          </tbody>
        </ReactCSSTransition>
      </Table>
    </div>);
  }
}

ConformanceList.contextTypes = {
  editingFields: PropTypes.array,
}
